import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import "./MessageField.css";
import Enum from "./../../../../utils/Enums";
import { getOrgType } from "./../../../../utils/Token";
const allowedFileTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

function MessageField({
  pqId,
  onSaveMessage,
  messageData,
  isPinned,
  onUnpinAllMessages,
  unPinTitle,
}) {
  const Info = getOrgType() == "Admin" ? Enum.AccessType : getOrgType() == "Vendor" ? Enum.Vendor : getOrgType() == "Client" ? Enum.Client : "";
  const accessTypes = Object.entries(Info).map(([key, value]) => ({
    label: key,
    id: value,
  }));

  const [inputMessageData, setInputMessageData] = useState(messageData);
  const defaultAccessType = accessTypes.find((obj) => obj.label === "Everyone") ?? {};
  const defaultAccessType2 = accessTypes.find((obj) => obj.label === "Admin") ?? {};
  const DAccessType = getOrgType() == "Client" ? defaultAccessType2 : defaultAccessType; //In Vendor & Client Default Admin
  const [accessType, setAccesType] = useState(DAccessType);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isMessageValidate, setMessageValidate] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  const MAX_MSG_LENGTH = 1000;

  let filteredAccessTypes = accessTypes.filter(
    ({ label }) => label
  );

  //let currentOrgType = getOrgType();

  // if (currentOrgType !== "Admin")
  //   filteredAccessTypes = filteredAccessTypes.filter(
  //     ({ label }) => label !== currentOrgType
  //   );

  const onAccessbtnClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleContextClick = (event) => {
    setAnchorEl(null);
    setAccesType(event);
  };

  const resetMessageField = () => {
    setInputMessageData((prev) => {
      return { ...prev, message: "", messageId: 0 };
    });

  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (
      inputMessageData?.message == null ||
      inputMessageData?.message?.trim() === ""
    ) {
      setMessageValidate(false);
      setValidationMessage("Please enter a message");
      return;
    }
    if (inputMessageData.message.length > MAX_MSG_LENGTH) {
      setMessageValidate(false);
      setValidationMessage(`Message should be ${MAX_MSG_LENGTH} characters or less`);
      return;
    }


    setMessageValidate(true);
    const formData = new FormData();
    formData.append("message", inputMessageData.message);
    formData.append("accessType", accessType.id);
    formData.append("PrequalificationId", pqId);
    formData.append("MessageId", inputMessageData?.messageId ?? 0);
    onSaveMessage(formData);
    resetMessageField();
  };

  const messageHandler = (event) => {
    const message = event.target.value;

    if (message.length > MAX_MSG_LENGTH) {
      setMessageValidate(false);
      setValidationMessage(`Message should be ${MAX_MSG_LENGTH} characters or less`);
    } else {
      setMessageValidate(true);
      setValidationMessage("");
    }

    setInputMessageData({ ...inputMessageData, message });
  };

  useEffect(() => {

    if (inputMessageData?.messageId > 0) {
      setAccesType(accessTypes.find((obj) => obj.id === inputMessageData.accessType));
    }
  }, []);

  useEffect(() => {
    if (!messageData.updatedOnBacked) {
      setInputMessageData(messageData);
      if (messageData?.accessType > 0)
        setAccesType(accessTypes.find((obj) => obj.id === messageData.accessType));
    }
  }, [messageData]);

  function handleFileInput(event) {
    const selectedFile = event.target.files[0];
    if (selectedFile !== undefined) {
      if (selectedFile.size > MAX_FILE_SIZE) {
        setMessageValidate(false);
        setValidationMessage("File size should be less than 10 MB");
        event.target.value = null;
        return;
      } else if (!allowedFileTypes.includes(selectedFile.type)) {
        setMessageValidate(false);
        setValidationMessage("Invalid file type");
        return;
      } else {
        setMessageValidate(true);
      }

      const formData = new FormData();
      formData.append("File", event.target.files[0]);
      formData.append("message", "Attachment");
      formData.append("accessType", accessType.id);
      formData.append("PrequalificationId", pqId);
      formData.append("HasAttachment", true);
      onSaveMessage(formData);
      resetMessageField();
      event.target.value = null;
    }
  }
  const handleEnterKey = (event) => {
    if (event.keyCode === 13 && !event.shiftKey) {
      submitHandler(event);
    }
  };
  return (
    <>
      {!isPinned && (
        <Box
          p={3}
          className="border-top position-absolute bottom-0 bg-white pb-2 pt-3"
          style={{ width: "100%", zIndex: "99" }}
        >
          <form onSubmit={submitHandler} className="d-flex gap-3 flex-nowrap align-items-end">
            <TextField multiline
              maxRows={4}

              className={`auto-height p-0 ${isMessageValidate ? 'rounded' : 'rounded border-danger'}`}
              placeholder="Message"
              // style={maxH}
              // border: 2px solid rgb(250,53,40);
              value={inputMessageData?.message || ""}
              onChange={messageHandler}
              onKeyDown={handleEnterKey}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton component="label">
                      <AddCircleOutlineIcon className="custom-icon-hover" />
                      <input type="file" onChange={handleFileInput} hidden />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <button
              className="send-btn ms-2 d-flex align-items-center btn btn-primary border-0 px-3"
              style={{ backgroundColor: "var(--primary-clr)", maxHeight: "3rem" }}
              type="submit"
            >
              <SendIcon />
            </button>
          </form>
          {!isMessageValidate && (
            <span className="text-danger">{validationMessage}</span>
          )}
          <div className="text-center pt-2">
            <span
              id="access-type-menu-button"
              aria-controls={open ? "access-type-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={onAccessbtnClick}
              className="to-show everyone cursor-pointer"
            >
              {accessType.label}
            </span>{" "}
            <span className="txt-clr-blue4">can see this message</span>
          </div>

          <Menu
            id="access-type-menu"
            MenuListProps={{ "aria-labelledby": "access-type-menu-button" }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            {filteredAccessTypes.map((option, idx) => (
              <MenuItem
                disabled={inputMessageData?.messageId > 0}
                className="context-menu-items"
                key={idx}
                onClick={handleContextClick.bind(null, option)}
              >
                {option.label}{" "}
                {option.id === accessType.id && (
                  <CheckRoundedIcon className="ms-auto txt-clr-blue1" />
                )}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      )}
    </>
  );
}

export default MessageField;
